import React from 'react';
import { PrinterIcon } from 'lucide-react';
const runOrder = ['Ask the artist: “What time is the last face done?”', 'Claim the window · lamps off', 'Collection sentence → all details, one table', 'Details first (rings → gown → the rest)', 'Candids while they’re in chairs', 'Directed set: buttons · earring · veil · window', 'Parents: dad’s look · mom’s hands', 'Dress on = CHECKPOINT 1 → text the second shooter'];
const sayThis = [{
  cue: 'Details',
  line: '“Borrowing the rings — they won’t leave this table.”'
}, {
  cue: 'Window',
  line: '“Best light in the building — stand right here.”'
}, {
  cue: 'Buttons',
  line: '“Start from the bottom. Every few, look up at her.”'
}, {
  cue: 'Dad',
  line: '“Hold her hands, step back, take your time.”'
}];
const breakPoints = [{
  delay: '+15 min',
  eats: 'The travel buffer to the first look',
  lose: 'Nothing yet — but you’re now on zero margin'
}, {
  delay: '+30 min',
  eats: 'The first look block compresses',
  lose: 'The quiet minutes after the reveal; you keep only the turn itself'
}, {
  delay: '+45 min',
  eats: 'First look and Round One portraits',
  lose: 'Every daylight couple photo now rides on golden hour — which may not come'
}, {
  delay: '+60 min',
  eats: 'The pre-ceremony reset',
  lose: 'You walk into the ceremony having never checked the room, and the mistakes compound from there'
}];
export function SamplePage() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-248" data-mp="3bqpbdba96txi">
      <div className="mx-auto max-w-5xl px-5" data-id="element-249" data-mp="36qkuvl9chz7a">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-250" data-mp="36p9qbj82snf4">
          This is what &ldquo;word for word&rdquo; actually means
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-251" data-mp="1vb4nwunigllw" />
        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-ink-soft" data-id="element-252" data-mp="1v9bghd52pxcu">
          Below is the one-page Printable that closes Volume 1. There&rsquo;s one for every
          part of the day. You print it, clip it to your bag, and the phone stays in your
          pocket.
        </p>

        <article className="mt-12 border border-ink/15 bg-ivory shadow-card" data-id="element-253" data-mp="1issj88ottv22">
          <header className="flex flex-wrap items-center justify-between gap-3 border-b border-ink/15 bg-ink px-6 py-4" data-id="element-254" data-mp="1iuwksjz96hz6">
            <h3 className="font-serif text-lg text-ivory" data-id="element-255" data-mp="192z97c4c1nzx">
              Getting Ready · <span className="text-gold" data-id="element-256" data-mp="190w6bri300ds">Run this order</span>
            </h3>
            <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-ivory/60" data-id="element-257" data-mp="1dva7kajfd1qd">
              <PrinterIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-258" data-mp="1045bfif9mrks" />
              One page · clip to bag
            </span>
          </header>

          <div className="grid gap-px bg-ink/10 sm:grid-cols-2" data-id="element-259" data-mp="q3v0y5km7y9b">
            <ol className="bg-ivory px-6 py-7" data-id="element-260" data-mp="v37x5gxdmhok">
              {runOrder.map((step, index) => <li key={step} className="flex gap-4 py-2 text-[15px] text-ink" data-id="element-261" data-mp="bhfuy1amaadd" data-mpi={index}>
                  <span className="w-5 shrink-0 font-serif text-gold-dark tabular-nums" data-id="element-262" data-mp="bjij0fs7ltfg">
                    {index + 1}
                  </span>
                  <span data-id="element-263" data-mp="lfvlo35qfhmc">{step}</span>
                </li>)}
            </ol>

            <div className="bg-white px-6 py-7" data-id="element-264" data-mp="gfziu78rtw8d">
              <p className="text-[10px] uppercase tracking-[0.24em] text-gold-dark" data-id="element-265" data-mp="gf7mgu7cnuh1">
                Say this
              </p>
              <dl className="mt-4 divide-y divide-ink/10" data-id="element-266" data-mp="ph749oq6v2l1">
                {sayThis.map(item => <div key={item.cue} className="py-3" data-id="element-267" data-mp="1463i62exf9tk">
                    <dt className="text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-268" data-mp="145k2ytgnuzj8">
                      {item.cue}
                    </dt>
                    <dd className="mt-1 font-serif text-lg leading-snug text-ink" data-id="element-269" data-mp="1d6i5t8fd5108">
                      {item.line}
                    </dd>
                  </div>)}
              </dl>
            </div>
          </div>

          <footer className="space-y-2 border-t border-ink/15 px-6 py-6 text-[13px] text-ink-soft" data-id="element-270" data-mp="32n3zzf2w37lq">
            <p data-id="element-271" data-mp="37lp1dhtvnxbr">
              <span className="text-[10px] uppercase tracking-[0.2em] text-gold-dark" data-id="element-272" data-mp="37l5j200bf6x7">
                Minutes
              </span>{' '}
              Details 20 · Candids 15 · Directed 15 · Dress + parents 15
            </p>
            <p data-id="element-273" data-mp="3hemc31smohzt">
              <span className="text-[10px] uppercase tracking-[0.2em] text-gold-dark" data-id="element-274" data-mp="2jpaxuf03b1pe">
                8-minute version
              </span>{' '}
              rings · gown · last buttons · veil · window · one hug
            </p>
            <p data-id="element-275" data-mp="2tm5sunx5mjyx">
              <span className="text-[10px] uppercase tracking-[0.2em] text-gold-dark" data-id="element-276" data-mp="2tlnpz8fzl7i1">
                If the dress is 15+ late
              </span>{' '}
              you&rsquo;re already in the 8-minute version. Decide the first look now.
            </p>
          </footer>
        </article>

        <h3 className="mt-16 text-center font-serif text-2xl sm:text-3xl text-ink" data-id="element-277" data-mp="cxa1x49w8cz4">
          And this is a Break Points table
        </h3>

        <div className="mt-8 overflow-hidden border border-gold-soft bg-white" data-id="element-278" data-mp="1xigo2zm3fhw4">
          <div className="hidden bg-gold-tint text-[11px] uppercase tracking-[0.18em] text-ink-soft sm:grid sm:grid-cols-[140px_1fr_1fr]" data-id="element-279" data-mp="1th54bapwhqvu">
            <div className="border-r border-gold-soft px-5 py-4" data-id="element-280" data-mp="1jpqykl7cvuu9">If Getting Ready runs</div>
            <div className="border-r border-gold-soft px-5 py-4" data-id="element-281" data-mp="1epw8ukzbhbas">It eats</div>
            <div className="px-5 py-4" data-id="element-282" data-mp="1enruf93sktw9">You lose for good</div>
          </div>

          {breakPoints.map((row, index) => <div key={row.delay} className={index > 0 ? 'border-t border-gold-soft/70' : ''} data-id="element-283" data-mp="15p6i3vowyb3x" data-mpi={index}>
              <div className="sm:grid sm:grid-cols-[140px_1fr_1fr]" data-id="element-284" data-mp="10rod2ge0og17">
                <h4 className="bg-gold-tint px-4 py-2.5 font-serif text-base text-gold-dark sm:border-r sm:border-gold-soft/70 sm:bg-transparent sm:px-5 sm:py-5 sm:text-lg" data-id="element-285" data-mp="3040lrbzv3dji">
                  {row.delay}
                </h4>

                <div className="grid grid-cols-2 sm:contents" data-id="element-286" data-mp="3e87ovz3nssn3">
                  <div className="border-r border-gold-soft/70 px-4 py-4 sm:px-5 sm:py-5" data-id="element-287" data-mp="3izheizp7jvyz">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-ink-muted sm:hidden" data-id="element-288" data-mp="358kw21ozwv5n">
                      It eats
                    </p>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-ink sm:mt-0 sm:text-[15px]" data-id="element-289" data-mp="3a7xlmu794gbx">
                      {row.eats}
                    </p>
                  </div>
                  <div className="px-4 py-4 sm:px-5 sm:py-5" data-id="element-290" data-mp="5rwegua51f1a">
                    <p className="text-[10px] uppercase tracking-[0.14em] text-blush-deep sm:hidden" data-id="element-291" data-mp="3nz2khu2sp4l7">
                      You lose for good
                    </p>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-ink-soft sm:mt-0 sm:text-[15px]" data-id="element-292" data-mp="3t003u9zjk4oa">
                      {row.lose}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-base leading-relaxed text-ink-soft" data-id="element-293" data-mp="29xwfa19uvoyh">
          That table doesn&rsquo;t exist in any posing guide. It&rsquo;s the difference
          between &ldquo;we&rsquo;re running late&rdquo; and knowing exactly what you just
          lost — and what you protect next.
        </p>
      </div>
    </section>;
}